import * as React from 'react'
import {connect} from "react-redux"
import {ApplicationState} from "../../store"
import {Button} from "@material-ui/core"
import SaveIcon from "@material-ui/icons/Save"
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab"
import {actionCategorySave, actionCategoryFetch} from "../../store/categories/actions"
import {actionActiveTabTitle } from '../../store/tabs/actions'
import {Tab} from '../Tab'
import {Validator} from '../../core/Validator'
import {CategoryDescriptor} from '../../models/Category'
import {Utility} from '../../core/Utility'
import {t} from "../../core/localization"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {EntityField} from "../../core/genericdocuments/EntityField"
import {FieldView} from "../components/FieldView"
import {categoryFieldsDescriptor} from "./CategoryFields"

export interface CategoryTabProps extends BaseTabProps{
	tab: Tab
}

export interface CategoryTabState extends BaseTabState{
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active
	}
}

class CategoryTab extends BaseTab<CategoryTabProps, CategoryTabState> {

	constructor(props: CategoryTabProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
    }

	componentWillMount() {

		if (this.props.item.id)
			actionCategoryFetch(this.props.item)
	}

	componentWillReceiveProps(nextProps: CategoryTabProps) {
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderForm()}
				{this.renderControls()}
			</div>
		)
	}

	renderForm(): React.ReactNode {

		let descriptor: EntityFieldsDescriptor<any> = categoryFieldsDescriptor

		return (<div className="create-form">
		{
			descriptor && descriptor.createFormFields.map(
				(entityField: EntityField<any>, index: number) => {
					const fieldName = entityField.name.toString()
					let value = Utility.formatString(this.getItemFromTabState(fieldName))
					return (
						<div style={{ marginBottom: "0px", padding: "0px" }}>
							{<FieldView value={value}
									autoFocus={index === 0} field={entityField} formState={null}
									setFormState={null}
									handleInputChange={(fieldName, value) => this.handleItemGenericInputChange(fieldName, value)}
									validationState={this.state.validation}
								/>}
							</div>
						)
					}
				)
			}
		</div>
		)
	}

	renderControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	onSaveClick () {
		let itemToSave = this.getItemFromTabState()

		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, CategoryDescriptor)

		if (validation.valid) {
			actionCategorySave(itemToSave)
			actionActiveTabTitle(t.Category + ': ' + this.getItemFromTabState('title'))
		}

		this.setState({ ...this.state, validation: validation });
	}

}

export default connect(mapStateToProps)(CategoryTab);
